// src/data/projectContent.js

const tokenIntroProject = [
    {
      title: "Introducción a la Tokenización de Activos",
      value: `
  ## ¿Qué es un Activo?
  
  Para nuestros propósitos, un activo es cualquier cosa con valor monetario asociado. Los activos pueden ser:
  
  - **Reales o personales**
  - Usados como medio de pago o garantía de deuda
  - **Tangibles o intangibles**, como:
    - Empresas
    - Marcas registradas
    - Derechos de mercado o producto
  
  ---
  
  ##  ¿Qué es la Tokenización?
  
  La tokenización es esencialmente el proceso de convertir los derechos de un activo en un **token digital en la blockchain**.
  
  Los activos que pueden tokenizarse incluyen:
  
  - Acciones
  - Oro
  - Petróleo
  - Bienes raíces
  
  ---
  
  ##  ¿Fungibles o No Fungibles?
  
  En tu recorrido por blockchain, encontrarás dos tipos principales de activos:
  
  - **Fungibles:** Son divisibles y más aptos para tokenización. Ej: acciones, monedas.
  - **No fungibles:** No son intercambiables entre sí. Ej: hipotecas, empresas individuales.
  
  > Ejemplo: Pocos compradores de tokens asumirían el riesgo de impago de una única hipoteca o el colapso de un solo negocio.
  
  ---
  
  ##  Consideraciones Legales
  
  No te preocupes, estoy aquí para facilitarte el camino.
  
  - Te proporcionaré **plantillas legales listas para usar**.
  - Aprenderás a **valorar tus activos** en relación con sus tokens.
  - Definirás los **derechos vinculados al token** emitido.
  
  ---
  
  ##  ¿Qué aprenderás?
  
  Este módulo te enseñará:
  
  - A registrar tu título de propiedad
  - A garantizar que tu **documentación legal sea válida**
  - A demostrar que realmente eres el propietario del activo que vas a fraccionar mediante tokens
  


      `,
    },
  ];
  
  export default tokenIntroProject;
  